module.exports = __webpack_public_path__ + "img/vector.3fc90d03.png";